<template>
  <div>
    <AppButton
      v-show="!disabled"
      class="w-100"
      variant="danger"
      @click="$emit('delete', parentValue)"
    >
      <AppIcon name="delete" type="danger" />
    </AppButton>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    parentValue: {
      type: Object,
      required: true,
    },
  },
}
</script>
